/*
	Generated on 07/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import RequireAuth from '@/commons/auth/RequireAuth'

import TambahMataKuliahPage from './containers/TambahMataKuliahPage'
import DaftarMataKuliahPage from './containers/DaftarMataKuliahPage'
import DetailMataKuliahPage from './containers/DetailMataKuliahPage'
import UbahMataKuliahPage from './containers/UbahMataKuliahPage'
import DetailMataKuliahPrasyaratPage from './containers/DetailMataKuliahPrasyaratPage'
import UbahMataKuliahPrasyaratPage from './containers/UbahMataKuliahPrasyaratPage'
import TambahMataKuliahPrasyaratPage from './containers/TambahMataKuliahPrasyaratPage'
import TambahGrupMataKuliahPage from './containers/TambahGrupMataKuliahPage'
import CariGrupMataKuliahPage from './containers/CariGrupMataKuliahPage'

const mataKuliahRoutes = [
{ 
	path: "/matakuliah/tambah",
	element: <RequireAuth permissionNeeded="CreateMataKuliah" ><TambahMataKuliahPage/></RequireAuth>
}

	
,
{ 
	path: "/matakuliah/ubah",
	element: <UbahMataKuliahPage />,
}

	
,
{ 
	path: "/matakuliah/:id/prasyarat/ubah",
	element: <RequireAuth permissionNeeded="UpdateMataKuliahPrasyarat" ><UbahMataKuliahPrasyaratPage/></RequireAuth>
}

	
,
{ 
	path: "/matakuliah/:id/prasyarat/tambah",
	element: <RequireAuth permissionNeeded="SaveMataKuliahPrasyarat" ><TambahMataKuliahPrasyaratPage/></RequireAuth>
}

	
,
{ 
	path: "/matakuliah/:id/grup/tambah",
	element: <TambahGrupMataKuliahPage />,
}

	
,
{ 
	path: "/matakuliah/:id/grup/cari",
	element: <CariGrupMataKuliahPage />,
}

,
{ 
	path: "/matakuliah/:id/prasyarat/:prasyaratId",
	element: <RequireAuth permissionNeeded="ReadMataKuliahPrasyarat" ><DetailMataKuliahPrasyaratPage/></RequireAuth>
}

	
,
{ 
	path: "/matakuliah",
	element: <DaftarMataKuliahPage />,
}

	
,
{ 
	path: "/matakuliah/:id",
	element: <DetailMataKuliahPage />,
}

	

]

export default mataKuliahRoutes
